module.exports = __webpack_public_path__ + "stu-res/img/icon-5.a37a1231.png";